import React, { Component } from 'react';
import Card from '../Node/Card';
import Filters from './Filters'
import Pagination from './Pagination'
import Loader from '../Elements/Loader';
import SearchForm from "./SearchForm";
import SelectedFilters from "./SelectedFilter";

class FacetBlock extends Component {
  constructor() {
    super();
    this.state = {
      terms: [],
      pageLimit: 15,
      pageOffset: 0,
      currentPage: 1,
      filterUrl: '',
      filters: [{
        title: 'Default',
        node: [{
          id: 'firstfilter',
          name: 'All categories',
        }]
      }],
      cards: [],
      selectedFilterId: 'firstfilter',
      selectedFilterName: 'All categories',
      pager: [],
      searchText: '',
      loading: true,
      foundResults: true,
      appRoot: window.location.origin,
    }
  }

  /**
   * Set url
   *
   * @param {string} id
   * @param {string} value
   */
  setUrl = (id, value) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('filter', id);
    urlParams.set('filtertext', value.replace(/[^\w]/g, '-'));

    window.history.replaceState(
      null,
      document.title,
      `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`,
    );
  }

  /**
   * Create card data
   *
   * @param {Object} cardData - Current card data
   * @param {Object} cardData.includedItem
   * @param {Object} cardData.attributes
   * @param {Object} cardData.relationships
   * @returns {{
   *   imageurl: string,
   *   title: string,
   *   sitelink: string,
   *   owner: string,
   *   alias: string,
   *   alt: string,
   *   category: array,
   * }} cardData
   */
  getCards = ({ includedItem, attributes, relationships }) => {
    const categories = [];

    relationships.field_categories.data.forEach(fieldCategory => {
      const category = this.state.terms.find(category => fieldCategory.id === category.id);
      if (category && category.name) {
        categories.push(category.name);
      }
    });
    return {
      imageurl: `${this.state.appRoot}${includedItem.attributes.uri.url}`,
      title: attributes.title.toString(),
      sitelink: attributes.field_sitelink[0].uri,
      owner: attributes.field_owner ? attributes.field_owner.value : '',
      alias: attributes.path.alias,
      alt: relationships.field_site_image.data[0].meta.alt,
      category: categories,
    };
  };

  /**
   * Get content data
   *
   * @param {*} url
   */
  contentFetcher = (url) => {
    this.setState({ loading: true });

    fetch(`${url}`, { 'method': 'GET' })
      .then((data) => data.json())
      .then(({ data, included, links }) => {
        const urlOffset = /(?:offset]=)([^&]+)/.exec(url) || /(?:offset%5D=)([^&]+)/.exec(url)
        const urlOffsetNumber = parseInt(urlOffset[1]) || 0;
        const isActualPage = urlOffsetNumber === this.state.pageOffset;

        if (isActualPage) {
          const cards = data.map((nomiees, index) => (
            this.getCards({
              relationships: nomiees.relationships,
              includedItem: included[index],
              attributes: nomiees.attributes,
            })
          ));

          this.setState({
            cards,
          });
        }

        this.getPaginatorData({
          url,
          links,
          pageNumber: (urlOffsetNumber / this.state.pageLimit) + 1,
          isfoundResults: data.length > 0,
        })

        this.setState({
          foundResults: data.length > 0,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      })
  }

  getPaginatorData = ({ url, links, pageNumber, isfoundResults }) => {
    let pages = [...this.state.pager]
    const isFirstPage = pageNumber === 1;
    const isVisitedFirst = pages.findIndex(p => p.id === `pagination--item-1`) !== -1;

    if ((!isFirstPage && links.first) && !isVisitedFirst) {
      this.contentFetcher(links.first.href);
    }

    if (links.next) {
      this.contentFetcher(links.next.href);
    }

    if ((pages.findIndex(p => p.id === `pagination--item-${pageNumber}`) === -1) && isfoundResults) {
      pages.push({
        href: url,
        id: `pagination--item-${pageNumber}`,
      })
    }

    this.setState({
      pager: pages,
    });
  }

  /**
   * Set search value
   *
   * @param {*} event
   */
  inputHandler = (event) => {
    const searchText = event && event.target.value || '';
    this.setState({
      searchText,
      filterUrl: '',
    }, () => {
      if (!event) {
        this.getFilteredNominees();
      }
    });
  }

  /**
   * Reset filters
   */
  closeButtonHandler = () => {
    const [firstFilterNode] = this.state.filters[0].node;
    this.setUrl(firstFilterNode.id, firstFilterNode.name);
    this.setState({
      selectedFilterId: firstFilterNode.id,
      selectedFilterName: firstFilterNode.name,
      filterUrl: '',
      pageOffset: 0,
      currentPage: 1,
    }, () => {
      this.getFilteredNominees();
    });
  }

  /**
   * Set text search filter
   */
  sendSearchText = () => {
    this.setState({
      loading: true,
      foundResults: true,
      filterUrl: `[title][operator]=CONTAINS&filter[title][value]=${this.state.searchText !== '' ? this.state.searchText : ''}&filter`,
      pageOffset: 0,
      currentPage: 1,
    }, () => {
      this.getFilteredNominees();
    });
  }

  /**
   * Send search text filter by submit button
   *
   * @param {*} event
   */
  submitHandler = (event) => {
    event.preventDefault();
    this.sendSearchText();
  }

  /**
   * Send search text filter by enter
   *
   * @param {*} event
   */
  keyStrokeHandler = (event) => {
    if (event.key === 'Enter') {
      this.sendSearchText();
    }
  }

  /**
   * Select filter handler
   *
   * @param {Object} filter - Selected filter data
   * @param {string} filter.id
   * @param {string} filter.name
   */
  handleCheckEvent = ({ id, name }) => {
    this.setUrl(id, name);
    this.setPageUrl(0);
    const allNomineesFilterId = this.state.filters[0].node[0].id;
    let filterUrl = ''
    if (id !== allNomineesFilterId) {
      filterUrl = `[field_categories.id]=${id}&filter`
    }

    this.setState({
      pager: [],
      selectedFilterId: id,
      selectedFilterName: name,
      filterUrl,
      pageOffset: 0,
      currentPage: 1,
    }, () => {
      this.getFilteredNominees();
    });
  }

  /**
   * Set page number in url
   *
   * @param {number} page
   */
  setPageUrl = (page) => {
    const urlParams = new URLSearchParams(window.location.search);

    if (page === 0) {
      urlParams.delete('page');
    } else {
      urlParams.set('page', page);
    }

    window.history.replaceState(
      null,
      document.title,
      `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`,
    )
  }

  /**
   * Pagination handler
   *
   * @param {number} page
   */
  handlePaginaTion = (page) => {
    window.scrollTo(0, 500)
    this.setPageUrl(page);

    this.setState({
      pageOffset: (page - 1) * this.state.pageLimit,
      currentPage: page,
    }, () => {
      this.getFilteredNominees();
    });
  }

  /**
   * Get category data
   */
  getCategory = async () => {
    try {
      const resp = await fetch(`${this.state.appRoot}/jsonapi/taxonomy_term/category`, { 'method': 'GET' });
      const { data } = await resp.json();
      const terms = data.map((category) => ({
        name: category.attributes.name,
        id: category.id,
      }));

      this.setState({ terms });
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Filter data for aside filter list
   */
  getCategoryFilters = async () => {
    const resp = await fetch(`${this.state.appRoot}/jsonapi/taxonomy_term/category_group`, { 'method': 'GET' });
    const { data } = await resp.json();
    const filters = data.map(item => {
      const relatedCategories = item.relationships.field_category.data.map(cat => this.state.terms.find(node => node.id === cat.id));

      return ({
        title: item.attributes.name,
        node: relatedCategories,
      });
    })

    this.setState((prev) => ({
      filters: [...prev.filters, ...filters],
    }));
  }

  /**
   * Get filtered nominees list
   */
  getFilteredNominees = () => {
    const url = `/jsonapi/node/nominees?filter${this.state.filterUrl}[field_ongoing][value]=1&filter[status][value]=1&include=field_site_image&fields[file--file]=uri&page[offset]=${this.state.pageOffset}&page[limit]=${this.state.pageLimit}`

    this.contentFetcher(`${this.state.appRoot}${url}`);
  }

  /**
   * Get filter name from filter list
   *
   * @param {string} baseFilter
   * @returns {string}
   */
  getSelectedFilterName = (baseFilter) => {
    let selectedFilterName = ''
    this.state.filters.forEach(filter => {
      filter.node.forEach(f => {
        if (f.id === baseFilter) {
          selectedFilterName = f.name
        }
      })
    })
    return selectedFilterName
  }

  async componentDidMount() {
    try {
      await this.getCategory()
      await this.getCategoryFilters()

      const urlParams = new URLSearchParams(window.location.search);
      let baseFilter = urlParams.get('filter');
      const page = parseInt(urlParams.get('page'));

      const allNomineesFilterId = this.state.filters[0].node[0].id;

      let filterUrl = '';
      if (baseFilter && baseFilter !== allNomineesFilterId) {
        filterUrl = `[field_categories.id]=${baseFilter}&filter`;
      } else {
        baseFilter = allNomineesFilterId
      }

      this.setState({
        selectedFilterId: baseFilter,
        selectedFilterName: this.getSelectedFilterName(baseFilter),
        pageOffset: page ? (page - 1) * this.state.pageLimit : 0,
        currentPage: page ? page : 1,
        filterUrl,
      }, () => {
        this.getFilteredNominees();
      });

    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { state, inputHandler, submitHandler, handleCheckEvent, handlePaginaTion, closeButtonHandler, keyStrokeHandler } = this;
    const { searchText, filters, loading, foundResults, cards, pager, selectedFilterId, selectedFilterName, currentPage } = state;

    return (
      <div className="container facet-block">
        <SearchForm
          selectedFilter={selectedFilterName}
          closeButtonHandler={closeButtonHandler}
          inputHandler={inputHandler}
          value={searchText}
          submitHandler={submitHandler}
          keyStrokeHandler={keyStrokeHandler}
        />
        <div className="nominees-block grid">
          <Filters
            filters={filters}
            handleCheckEvent={handleCheckEvent}
            selectedFilter={selectedFilterId}
            closeButtonHandler={closeButtonHandler}
          />
          {window.innerWidth < 900 ?
            <div className='selected-filter--mobile'>
              <SelectedFilters
                selectedFilter={selectedFilterName}
                closeButtonHandler={closeButtonHandler}
              />
            </div>
            : null}
          <div className="card-block">
            {loading ? <Loader /> :
              <div className="grid">
                {foundResults ?
                  cards.map(card => {
                    return <Card
                      key={card.title}
                      alias={card.alias}
                      title={card.title}
                      imageUrl={card.imageurl}
                      owner={card.owner}
                      category={card.category}
                      alt={card.alt}
                    />
                  }) :
                  <h2>No results found</h2>}
              </div>}
            <Pagination pager={pager} handlePaginaTion={handlePaginaTion} currentPage={currentPage} />
          </div>
        </div>
      </div>
    )
  }
}

export default FacetBlock;
